var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarR = function SvgDefaultAvatarR(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "default-avatar_r_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".default-avatar_r_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2 55.3c4.5 0 6.8-.4 6.8-1.6 0-.9-1-1.2-3.7-1.3-.5-.2-.7-2.1-.7-4.5v-5.5h4.8c2.8 0 3.9 2.6 4.9 5.7 1.2 3.6 2.3 7.2 6.6 7.2 2.8 0 4.6-1.7 4.6-2.8 0-.4-.2-.7-.6-.8-.5 0-1.1.5-2.2.3-1.4-.2-2-1.6-3.1-4.1-1.3-3.1-2.6-5.9-5.4-6.8 3.6-1.2 6.1-4 6.1-7.9 0-4.3-3-8.1-10.5-8.1-2.2 0-4.9.2-6.2.2H31c-3.1 0-5.1.3-5.1 1.5 0 .9 1 1.2 3.2 1.3.5.2.6 2.1.6 4.5v15.3c0 2.9-.1 4.3-.6 4.5-2.2.1-3.2.4-3.2 1.3 0 1.2 2.3 1.6 6.3 1.6zm2.6-15.7v-7.1c0-2.3.1-3.9.5-4.2 1-.3 2.4-.4 3.8-.4 5.1 0 6.3 3.4 6.3 6 0 3.6-2 5.8-6.7 5.8-1.4.1-2.6 0-3.9-.1z"
  })));
};
export default SvgDefaultAvatarR;